import { defineMessages } from '@jutro/locale';

export default defineMessages({
    makeMoreChanges: {
        id: 'ml.endorsement.common.policyChangeSummary.Make more changes',
        defaultMessage: 'Make more changes'
    },
    agentMessage: {
        id: 'ml.endorsement.common.policyChangeSummary.agentMessage',
        defaultMessage: 'This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.'
    },
    updatedQuotePremium: {
        id: 'ml.endorsement.common.policyChangeSummary.Updated Quote Premium',
        defaultMessage: 'Updated Quote Premium'
    },
    premiumUpdates: {
        id:  'ml.endorsement.common.policyChangeSummary.Premium Updates',
        defaultMessage: 'Premium Updates'
    },
    effectiveDate: {
        id: 'ml.endorsement.common.policyChangeSummary.Effective Date',
        defaultMessage: 'Effective Date'
    },
    effectiveDateMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.effectiveDateMsg',
        defaultMessage: '{effectiveDate}: {date}'
    },
    editEffectiveDate: {
        id: 'ml.endorsement.common.policyChangeSummary.Edit Effective Date',
        defaultMessage: 'Edit Effective Date'
    },
    previousPremium: {
        id: 'ml.endorsement.common.policyChangeSummary.Previous Premium',
        defaultMessage: 'Previous Premium'
    },
    difference: {
        id: 'ml.endorsement.common.policyChangeSummary.Difference',
        defaultMessage: 'Difference'
    },
    adjustedProratedPremium: {
        id: 'ml.endorsement.common.policyChangeSummary.Adjusted Prorated Premium',
        defaultMessage: 'Adjusted Prorated Premium'
    },
    newFullTermPremium: {
        id: 'ml.endorsement.common.policyChangeSummary.New Full Term Premium',
        defaultMessage: 'New Full Term Premium'
    },
    submitChanges: {
        id: 'ml.endorsement.common.policyChangeSummary.SUBMIT CHANGES',
        defaultMessage: 'SUBMIT CHANGES'
    },
    quoteProposal: {
        id: 'ml.endorsement.common.policyChangeSummary.QUOTE PROPOSAL',
        defaultMessage: 'QUOTE PROPOSAL'
    },
    coveragePackageLevelLabel: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.coveragePackageLevel',
        defaultMessage: '<a>COVERAGE LEVEL</a>'
    },
    offeringDefinitionsLabel: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.offeringDefinitions',
        defaultMessage: 'Offering Definitions'
    },
    year: {
        id: 'ml.endorsement.common.policyChangeSummary.year',
        defaultMessage: 'year'
    },
    sixMonth: {
        id: 'ml.endorsement.common.policyChangeSummary.6 month',
        defaultMessage: '6 month'
    },
    autoChgOccured: {
        id: 'ml.endorsement.common.policyChangeSummary.Some automatic changes have occurred',
        defaultMessage: 'Some automatic changes have occurred.'
    },
    checkPolicyBelow: {
        id: 'ml.endorsement.common.policyChangeSummary.Please check your policy below',
        defaultMessage: 'Please check your policy below.'
    },
    coverageChangesWarningMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.coverageChangesWarningMsg',
        defaultMessage: '{message1} {message2}'
    },
    coverageLevelChangeWarningMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.coverageLevelChangeWarningMsg',
        defaultMessage: '<strong>Important</strong>: This policy’s Coverage Level will change to {newCoverageLevel} at the next renewal date. If the customer wants to update the Coverage Level of the other policies included in the package as well, please make those changes now to retain an applicable package commission rate on this policy.'
    },
    coverageLevelChangeWarningAddedCovsMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.coverageLevelChangeWarningAddedCovsMsg',
        defaultMessage: '<div>The package was changed due to addition of below coverages:</div>'
    },
    coverageLevelChangeWarningRemovedCovsMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.coverageLevelChangeWarningRemovedCovsMsg',
        defaultMessage: '<div>The package was changed due to removal of below coverages:</div>'
    },
    coverageLevelChangeWarningUpdatedCovsMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.coverageLevelChangeWarningUpdatedCovsMsg',
        defaultMessage: '<div>The package was changed due to change in below coverages:</div>'
    },
    unableToProceedCallAgency: {
        id: 'ml.endorsement.common.policyChangeSummary.unableToProceedCallAgency',
        defaultMessage: '{message1} {message2}'
    },
    conflictsPriorChange: {
        id: 'ml.endorsement.common.policyChangeSummary.Some automatic changes have occurred',
        defaultMessage: 'You are unable to proceed as information conflicts with a prior change.'
    },
    callAgency: {
        id: 'ml.endorsement.common.policyChangeSummary.Some automatic changes have occurred',
        defaultMessage: 'To resolve, please chat or call Agency Resource Center at 1-800-255-0332.'
    },
    deviceRemovedMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.deviceRemovedMsg',
        defaultMessage: 'Your Smart Home device has been removed. Your quoted premium has been adjusted.'
    },
    emailQuoteSuccessMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.emailQuoteSuccessMsg',
        defaultMessage: 'Thank you. An email with your quote has been sent to {emailAddress}.'
    },
    proposeQuoteErrorMsg: {
        id: 'ml.endorsement.common.policyChangeSummary.proposeQuoteErrorMsg',
        defaultMessage: 'Quote proposal document is not available yet. Please try again later.'
    },
    coverageDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Coverage details',
        defaultMessage: 'Coverage details'
    },
    billingDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Billing details',
        defaultMessage: 'Billing details'
    },
    communicationPreferences: {
        id: 'ml.endorsement.common.policyChangeSummary.Communication preferences',
        defaultMessage: 'Communication preferences'
    },
    addressDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Address details',
        defaultMessage: 'Address details'
    },
    interestedPartiesDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Interested parties details',
        defaultMessage: 'Interested parties details'
    },
    discountDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Discount details',
        defaultMessage: 'Discount details'
    },
    propertyDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Property details',
        defaultMessage: 'Property details'
    },
    additionalPolicyInfo: {
        id: 'ml.endorsement.common.policyChangeSummary.Additional Policy Info',
        defaultMessage: 'Additional Policy Info'
    },
    driverDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Driver details',
        defaultMessage: 'Driver details'
    },
    vehicleDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Vehicle details',
        defaultMessage: 'Vehicle details'
    },
    watercraftExposures: {
        id: 'ml.endorsement.common.policyChangeSummary.Watercraft exposures',
        defaultMessage: 'Watercraft exposures'
    },
    locationExposures: {
        id: 'ml.endorsement.common.policyChangeSummary.Location exposures',
        defaultMessage: 'Location exposures'
    },
    businessActivityDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Business activity details',
        defaultMessage: 'Business activity details'
    },
    employerGroupAssocDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Employer/Group Association Details',
        defaultMessage: 'Employer/Group Association Details'
    },
    underlyingPolicyDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Underlying Policy Details',
        defaultMessage: 'Underlying Policy Details'
    },
    excludedDriversDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Excluded drivers details',
        defaultMessage: 'Excluded drivers details'
    },
    listVehicles: {
        id: 'ml.endorsement.common.policyChangeSummary.List vehicles',
        defaultMessage: 'List vehicles'
    },
    householdMembersDetails: {
        id: 'ml.endorsement.common.policyChangeSummary.Household members details',
        defaultMessage: 'Household members details'
    },
    businessActivity: {
        id: 'ml.endorsement.common.policyChangeSummary.Business Activity',
        defaultMessage: 'Business Activity'
    },
    ampDwellingHeaderText: {
        id: 'ml.endorsement.common.policyChangeSummary.Your updated home policy change',
        defaultMessage: 'Your updated home policy change'
    },
    ampRenterHeaderText: {
        id: 'ml.endorsement.common.policyChangeSummary.Your updated renters policy change',
        defaultMessage: 'Your updated renters policy change'
    },
    ampCondoHeaderText: {
        id: 'ml.endorsement.common.policyChangeSummary.Your updated condo policy change',
        defaultMessage: 'Your updated condo policy change'
    },
    ampPAHeaderText: {
        id: 'ml.endorsement.common.policyChangeSummary.Your updated auto policy change',
        defaultMessage: 'Your updated auto policy change'
    },
    ampPUPHeaderText: {
        id: 'ml.endorsement.common.policyChangeSummary.Your updated umbrella policy change',
        defaultMessage: 'Your updated umbrella policy change'
    },
    ampSubHeaderText: {
        id: 'ml.endorsement.common.policyChangeSummary.Hi x, your premium changed by x',
        defaultMessage: 'Hi {name}, your premium changed by {amount}'
    },
    ampParagraphText: {
        id: 'ml.endorsement.common.policyChangeSummary.Please review the policy summary below before submitting your policy changes. Refer to your policy documents for complete details. In the event of a conflict, the policy prevails.',
        defaultMessage: 'Please review the policy summary below before submitting your policy changes. Refer to your policy documents for complete details. In the event of a conflict, the policy prevails.'
    },
    confirmationTitle: {
        id: 'ml.endorsement.common.policyChangeSummary.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    confirmationDesc: {
        id: 'ml.endorsement.common.policyChangeSummary.Are you sure you want to cancel this policy change?',
        defaultMessage: 'Are you sure you want to cancel this policy change?'
    },
    yes: {
        id: 'ml.endorsement.common.policyChangeSummary.YES',
        defaultMessage: 'YES'
    },
    cancel: {
        id: 'ml.endorsement.common.policyChangeSummary.CANCEL',
        defaultMessage: 'CANCEL'
    },
    windstormHailDeductibleBumpedWarning: {
        id: 'ml.endorsement.common.policyChangeSummary.WindstormHailDeductibleBumped',
        defaultMessage: 'The Windstorm or Hail Deductible was updated to the minimum required deductible.'
    },
    roofLossSettlementBumpedWarning: {
        id: 'ml.endorsement.common.policyChangeSummary.RoofLossSettlementBumped',
        defaultMessage: 'Roof Loss Settlement was updated to Scheduled Roof as required.'
    },
    allOtherPerilBumpedWarning: {
        id: 'ml.endorsement.common.policyChangeSummary.AllOtherPerilBumped',
        defaultMessage: 'The All Other Perils deductible was updated to the minimum required deductible.'
    },
    premiumChangedAfterVehicleMvrWarning: {
        id: 'ml.endorsement.common.policyChangeSummary.premiumChangedWarning',
        defaultMessage: 'The previously quoted premium has changed due to the entry of additional information.'
    },
    grcAvailableBumpedWarning: {
        id: 'ml.endorsement.common.policyChangeSummary.GRCAvailableBumped',
        defaultMessage: 'Blanket Property and/or Guaranteed Rebuild is not available for this risk and the Building Property Loss Settlement and building code coverage have been updated.'
    },
    followingdocIssues: {
        id: 'ml.endorsement.common.policyChangeSummary.followingdocIssues',
        defaultMessage: 'The following underwriting issues have been identified:'
    },
    ineligiblePolicy: {
        id: 'ml.endorsement.common.policyChangeSummary.ineligiblePolicy',
        defaultMessage: 'Proof required'
    },
    unableToContinueWithPolicy: {
        id: 'ml.endorsement.common.policyChangeSummary.documentUploadissues.provideInfo',
        defaultMessage: 'Provide requested info to proceed.'
    },
    reason: {
        id: 'ml.endorsement.common.policyChangeSummary.uwissues.reason',
        defaultMessage: 'Contingency :'
    },
    uploadProof: {
        id: 'ml.endorsement.common.policyChangeSummary.upload',
        defaultMessage: 'Upload Proof'
    },
    hideAllIssues: {
        id: 'ml.endorsement.common.policyChangeSummary.hideAllIssues',
        defaultMessage: 'Hide all issues'
    },
    showAllIssues: {
        id: 'ml.endorsement.common.policyChangeSummary.showAllIssues',
        defaultMessage: 'Show all issues'
    },
    maritalStatusRelationshipWarning: {
        id: 'ml.endorsement.common.policyChangeSummary.maritalStatusRelationshipWarning',
        defaultMessage: "Relationship mismatch: only single driver(s) present with relationship to insured as 'Spouse/Co-Insured'. Please review and confirm Marital Status before proceeding"
    }
});